import React, { Component } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../api';
import { Button, Modal, Input, Checkbox, TextArea, Form, Dropdown, Grid, Segment, Dimmer, Loader, Header } from 'semantic-ui-react';
import { FilePond } from 'react-filepond';
import { apiUrl } from "../../config.js"
import { AuthService } from '../../services/auth-service'
import { Link } from 'react-router-dom';

const authService = new AuthService();


class CreateCase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
      
            contactName:  authService.getUserData(AuthService.FIRSTNAME_KEY) + " " + authService.getUserData(AuthService.SURNAME_KEY) , 
            contactEmail:  authService.getUserData(AuthService.EMAIL_KEY), 
            clientId : authService.getUserData(AuthService.CUSTOMER_ID_KEY),
            caseDetails: '',
            escalationFlag: false,
            attachments: [],
            submittingInProgress: false,
            caseType: '',
            caseCategory: '',
            subCategory: '',
            updateDetails : '',
            fileList : [],
            contactNumber : '',
            caseTypes: ['Enquiry', 'Request', 'Issue'],
            caseCategories: [],
            subCategories: [],
            customerId: authService.getUserData(AuthService.CUSTOMER_ID_KEY),
            sector: authService.getUserData(AuthService.SECTOR),



            // This is a placeholder. Replace with your actual data structure
            categories: {
                'Enquiry': {
                    'AMR installation': ['None'],
                    'Supplier Invoice Details': ['Meter Reads', 'Charges', 'Period Covered', 'Other'],
                    'Recharge': ['Meter Read Query', 'Recharge details'],
                    'Siteworks enquiry': ['None'],
                    'Consumption Data': ['None'],
                    'Other': ['None'],
                    'Database': ['None']
                },
                'Request': {
                    'Information to support supplier payments': ['Remittance Request', 'Statement of Account Request', 'Batch / Journal information'],
                    'Billing Address Amendment': ['None'],
                    'Add or Remove a Site / Meter': ['None'],
                    'Data Request': ['Invoices', 'Interval Data'],
                    'Recharge Request': ['Latest Recharge period', 'Historic recharge period', 'New recharge set up'],
                    'Report': ['None'],
                    'Other': ['None']
                },
                'Issue': {
                    'Missing Data': ['Invoices', 'Interval Data', 'Other'],
                    'Supplier invoice issue': ['Meter Reads', 'Charges', 'Period Covered', 'Incorrect billing address', 'Incorrect name on the account', 'Invoice for site not recognised', 'Other'],
                    'Meter Read issue': ['Billing to estimates', 'Other'],
                    'Payment Journal Issue': ['Missing Journal'],
                    'Recharges': ['Meter Read corrections', 'Tenant Correction', 'Usage Correction'],
                    'Debt Issue': ['Payment reminder received', 'Disconnection notice received'],
                    'Other': ['None']
                }
            }
        };
    }

    

    setOpen = (open) => {
        this.setState({ modalOpen: open });


       
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    handleActionChange = (e, { value }) => {
        this.setState({ actionType: value });
        this.setOpen(true);
    }

    getEscalationNumber() {
        switch(this.state.clientId) {
            case '15592': //JLL
                return '01253 785230';
            case '4799': //Segro
            case '364823': //Segro
            case '365950': //Segro
                return '01253 785090';
            case '355200': //LandG
                return '01253 785240';
            case '143068': //Hammersons
            case '365855': //PHP Tradeco
                return '01253 785174';
            default: //Default
                return '01253 785235';
        }
    }

    handleEscalationChange = (e, { checked }) => {
        if(checked) {
            this.setState({ showEscalationMessage: true });

        }
        this.setState({ escalationFlag: checked });
    }

    handleFileChange = (e) => {
        this.setState({ attachments: [...this.state.attachments, ...e.target.files] });
    }

    notify = (message, error = false, refresh = false) => {
        if (error) {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 50,
                autoClose: false
            });
        }else if (refresh){
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               onClose: () => {
                this.props.history.push("/");
                window.location.reload();
               }
            });
        } else {
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               closeOnClick: false
            });
        }
    }

    handleSubmit = () => {
        
        if(this.state.submittingInProgress)
        {
            this.notify("Submission in progress please wait", true);
            return;
        }

            // Validation for dropdowns based on visibility logic
                if (this.state.subjectLine === '' || this.state.updateDetails === '' || this.state.caseType === '' ||
                (this.state.caseType !== '' && this.state.caseCategory === '') ||
                (this.state.caseCategory !== '' && this.state.subCategory === '' && this.state.subCategories.length > 1)) {
                this.notify("Please fill in all required fields before submitting", true);
                return;
            }

            if (this.state.contactEmail === '' || this.state.contactName === '' || this.state.contactNumber === '' ) {
            this.notify("Please fill in all contact details before submitting", true);
            return;
        }

        this.setState({
                submittingInProgress: true,
        });
        const formData = new FormData();
        
        formData.append("subjectLine", this.state.subjectLine);

        formData.append("contactName", this.state.contactName);
        formData.append("contactEmail", this.state.contactEmail);
        formData.append("contactNumber", this.state.contactNumber);

        if(this.props.supplementalInfo)
        {
            formData.append("updateDetails", this.state.updateDetails + "\n" + this.props.supplementalInfo);

        }else
        {
        formData.append("updateDetails", this.state.updateDetails);
        }
        formData.append("escalated", this.state.escalationFlag);
        formData.append("fileString", JSON.stringify(this.state.fileList));


        if(this.props.assetLabel === "Failed meter read submission")
        {
           
             formData.append("caseType", 'Issue');
             formData.append("caseCategory", 'Meter Read issue');
             formData.append("caseSubCategory", 'Other');
           
        }else
        {
            formData.append("caseType", this.state.caseType || '');
            formData.append("caseCategory", this.state.caseCategory || '');
            formData.append("caseSubCategory", this.state.subCategory || '');
        }

        formData.append("siteId", this.props.siteKey);
        formData.append("meterId", this.props.meterSiteKey);
        formData.append("utility", this.props.utility);
        formData.append("assetLabel", this.props.assetLabel);
        formData.append("clientId", this.state.clientId);
        formData.append("sector", this.state.sector);


        
        // try {
        api.postSubmitNewCase(formData)
            .then(verifyRes => {


                if (verifyRes.success) {

                    this.setState({
                        open: false,
                        modalOpen:false,
                        submittingInProgress: false,
                      
                        updateDetails:"",
                        escalationFlag:false,
                        actionType:"",
                        fileList:[],
                        caseType: '',
                        caseCategory: '',
                        subCategory: ''
                       
                    });

                    this.notify((
                        <div>
                          Your {this.state.caseType} has been sent to the team, and a member of the team will be in touch in due course. Your reference is: <b>{verifyRes.id}</b>
                          <br></br><br></br>Please allow up to 30 minutes for your case to appear in the portal.
                        </div>
                      ), false);

                } else {
                    this.setState({
                        open: false,
                        submittingInProgress: false
                    });
                    if (verifyRes.mappingError) {
                        this.notify("Error submitting - contact IT Helpdesk. Code(MXX1)", true);
                    }else if(verifyRes.sfError)
                    {
                        this.notify("Error submitting - contact IT Helpdesk. Code(SXX1)", true);

                    }else
                    {
                        this.notify("Error submitting - contact IT Helpdesk", true);

                    }
                }
            })
            .catch((error) => {
                this.setState({
                    open: false,
                    submittingInProgress: false
                });
                this.notify("Unhandled Error - contact IT Helpdesk", true);
            });
    }

    handleCaseTypeChange = (e, { value }) => {
        this.setState({
            caseType: value,
            caseCategories: Object.keys(this.state.categories[value]),
            subCategories: []
        });
    }

    handleCaseCategoryChange = (e, { value }) => {
        this.setState({
            caseCategory: value,
            subCategories: this.state.categories[this.state.caseType][value],
            showInfoBox: value === "Add or Remove a Site / Meter" // Set flag based on the selected case category
        });
    }

    handleSubCategoryChange = (e, { value }) => {
        this.setState({
            subCategory: value
        });
    }
    

    render() {
        const caseTypeOptions = this.state.caseTypes.map(type => ({ key: type, value: type, text: type }));
        const caseCategoryOptions = this.state.caseCategories.map(category => ({ key: category, value: category, text: category }));
        const subCategoryOptions = this.state.subCategories.map(subcategory => ({ key: subcategory, value: subcategory, text: subcategory }));

        return (
            <Grid.Column>
                <Button compact floated='right' onClick={() => this.setState({ modalOpen: true })
                }>Create New Case</Button>

                <Modal
                    open={this.state.showEscalationMessage}
                    size={'mini'}
                >
                    <Modal.Header>Escalate this request?</Modal.Header>
                    <Modal.Content>

     

                        <Modal.Description>
                            <p>
                            If this request requires an update within the next 24 hours, please call {this.getEscalationNumber()}
                               
                            </p>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='black' onClick={() => this.setState({ showEscalationMessage: false })}>Dismiss</Button>
                        
                    </Modal.Actions>
                </Modal>

                <Modal size="small" open={this.state.modalOpen} onClose={() => this.setState({ modalOpen: false })}>
                    <Modal.Header>Create New Case</Modal.Header>
                    <Modal.Content>

                        <Segment>
                        <Header as='h2'>{this.props.assetLabel}</Header>
                            <Dimmer active={this.state.submittingInProgress}>
                                <Loader>Submitting...</Loader>
                            </Dimmer>
                            <Header as='h2'>Case Details</Header>
                            {(this.props.assetLabel !== "Failed meter read submission") &&
                            <>
                            <Input
                                    fluid placeholder='Subject Line' name="subjectLine" value={this.state.subjectLine} onChange={this.handleChange} /><br />
                            <Dropdown
                                fluid
                                selection
                                placeholder='Select case type'
                                options={caseTypeOptions}
                                value={this.state.caseType}
                                onChange={this.handleCaseTypeChange}
                            />
                           {
    this.state.caseType !== '' &&
    <Dropdown
        fluid
        selection
        placeholder='Select case category'
        options={caseCategoryOptions}
        value={this.state.caseCategory}
        onChange={this.handleCaseCategoryChange}
    />
}
{
     this.state.caseCategory !== '' && !(subCategoryOptions.length === 1 && subCategoryOptions[0].key === 'None') &&
    <Dropdown
        fluid
        selection
        placeholder='Select sub-category'
        options={subCategoryOptions}
        value={this.state.subCategory}
        onChange={this.handleSubCategoryChange}
    />
}
</> }

 {/* Info box for "Add or Remove a Site / Meter" case category */}
 {this.state.showInfoBox ? (
                  <Segment inverted color='green'>

                <p>
                  To make changes to a site or meter, please go to the Sites page and either:
                </p>
                <ul>
                  <li>Find the site requiring changes and log the required changes from there</li>
                  <li>Select {this.state.customerId === "4799" ? 'New Acquisition' : 'Add New Site'} from the Sites page and submit the changes from there
                 </li>
                </ul>
                </Segment>
            ) : (
                            <Grid>
                            <Grid.Column>
                                <br></br>
                                <Header as='h2'>Your Details</Header>

                              <Form>
                        
                                <Input
                                    fluid placeholder='Name' name="contactName" value={this.state.contactName} onChange={this.handleChange} /><br />

                                <Input
                                    fluid placeholder='Contact Email' name="contactEmail" value={this.state.contactEmail} onChange={this.handleChange} /><br />

<Input
                                    fluid placeholder='Contact Number' name="contactNumber" value={this.state.contactNumber} onChange={this.handleChange} /><br />
                                <Header as='h2'>Request Details</Header>

                                <TextArea
                                    fluid placeholder='Type your update here...' name="updateDetails" value={this.state.updateText} onChange={this.handleChange} /><br />

                                

                                <Checkbox  onChange={this.handleEscalationChange} label='Do you require this case to be escalated?'></Checkbox><br />
                                </Form>

                                <Grid.Column>
<br></br>
<Header as='h2'>Supporting Documents</Header>
<FilePond onupdatefiles={this.onFilesUpdated}  maxFileSize="7MB" labelMaxFileSizeExceeded="File is too Large" labelMaxFileSize="Maximum file size is {filesize}" allowMultiple={true} allowRevert={false} allowRemove={false} allowProcess={false} 
  acceptedFileTypes={[
    'image/jpeg',
    'image/png',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/msword', // .doc
    'application/pdf', // .pdf
    'text/csv', // .csv
    'image/tiff' // .tif
]}
server={{
    process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
        this.setState({ showInfoHide: true })
        const formData = new FormData();


       
        formData.append(fieldName, file, file.name);
        formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
        formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
        const request = new XMLHttpRequest();

        request.open('POST', `${apiUrl}/Documents/PublishPrivateDocument`);

        request.setRequestHeader(
            'Authorization', `bearer ${localStorage.getItem("token")}`);

        request.upload.onprogress = (e) => {
            try
            {
            progress(e.lengthComputable, e.loaded, e.total);
            }catch
            {
            
                error("Failed please check file size")
            }

        };

        request.onerror = (e) =>
        {
          
            error("Failed please check file size")
        }

        request.onload = (e) => {
            var obj = JSON.parse(e.srcElement.response);



            if (request.status >= 200 && request.status < 300) {

                if (obj.hasErrors) {


                    error("Failed")


                } else {


                    let myArr = [...this.state.fileList]
                     myArr.push(obj.fileId)
                    this.setState({
                        fileList: myArr
                    })

                    load("Success");
                }

            }
            else {


                error('failed upload please check the file format.');
            }
        };


        request.send(formData);

        return {

            abort: () => {
                request.abort();
                abort();
            }
        };
    }
}} />
</Grid.Column>
                            
                            </Grid.Column>
                            </Grid>
            )}
                        
                        </Segment>
                    </Modal.Content>
                    <Modal.Actions>
                    {this.state.showInfoBox ? (


                        <Link to="/sites">
                                               <Button >Go to Sites</Button>

                      </Link>


                    ) : (
                    <Button onClick={this.handleSubmit}>Submit</Button>
                    )}
                                <Button onClick={() => this.setOpen(false)}>Cancel</Button>
                        
                    </Modal.Actions>
                </Modal>
            </Grid.Column>
        );
    }
}

export default CreateCase;